import React from 'react';
import Icon from '@ant-design/icons';
import { ButtonType, Button, ButtonPropsType } from 'components/Controls/Button';
import EyeOnSvg from './eyeOn.svg';

interface IconButtonPropsType extends ButtonPropsType {
  iconSize?: number;
}

export const EyeOnIcon = (props: any) => <Icon component={EyeOnSvg} {...props} />;

export const EyeOnIconButton = React.forwardRef<HTMLButtonElement | HTMLAnchorElement, IconButtonPropsType>(
  ({ size = 'medium', iconSize = 24, type = ButtonType.OutlineIcon, ...props }, ref) => (
    <Button
      ref={ref}
      type={type}
      icon={<EyeOnSvg width={iconSize} height={iconSize} />}
      size={size}
      {...props}
    />
  ),
);
EyeOnIconButton.displayName = 'EyeOnIconButton';
